import { getDefaultTeam } from "./getDefaultTeam";
import { updateDefaultTeam } from "./updateDefaultTeam";
import { getConfigsApp } from "./getConfigsApp";
import { getProductsConfig } from "./getProductsConfig";
import { patchConfigProducts } from "./patchConfigProducts";

export const configService = {
  getDefaultTeam,
  updateDefaultTeam,
  getConfigsApp,
  getProductsConfig,
  patchConfigProducts,
};
